var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiddenEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "428px",
    height: "206px",
    viewBox: "0 0 428 206",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flags-/-production-/-empty-state",
    transform: "translate(-616.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(616.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 428,
    height: 206
  }), /*#__PURE__*/React.createElement("g", {
    id: "illusTeamEmptyState",
    transform: "translate(33.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_235_",
    transform: "translate(148.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_243_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.85,0 C49.0875,0 63,16.0590406 63,35.7313653 L63,35.7313653 L62.9125,35.7313653 L62.9125,136 L0,136 L0,35.7313653 L0.00418915,35.1393409 C0.280315,15.641094 14.1715,0 31.15,0 L31.15,0 Z M40,47 L23,47 C14.7157288,47 8,53.7157288 8,62 C8,70.2842712 14.7157288,77 23,77 L23,77 L40,77 C48.2842712,77 55,70.2842712 55,62 C55,53.7157288 48.2842712,47 40,47 L40,47 Z",
    id: "Combined-Shape",
    fill: "#5A5B5C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#5A5B5C",
    x: 24,
    y: 61,
    width: 16,
    height: 4,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#474646",
    transform: "translate(79.500000, 40.500000) rotate(98.000000) translate(-79.500000, -40.500000) ",
    x: 75,
    y: 34,
    width: 9,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#474646",
    fill: "#474646",
    transform: "translate(78.500000, 26.000000) rotate(68.000000) translate(-78.500000, -26.000000) ",
    x: 74.5,
    y: 20.5,
    width: 8,
    height: 11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,66.2 C177.4,66.2 175.3,64.1 175.3,61.6 C175.3,59.1 177.4,57 179.9,57 C182.4,57 184.5,59.1 184.5,61.6 C184.6,64.1 182.5,66.2 179.9,66.2 Z",
    id: "XMLID_57_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_242_",
    transform: "translate(154.000000, 57.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,9.2 C2.9,9.2 0.8,7.1 0.8,4.6 C0.8,2.1 2.9,-5.68434189e-14 5.4,-5.68434189e-14 C7.9,-5.68434189e-14 10,2.1 10,4.6 C10,7.1 7.9,9.2 5.4,9.2 Z",
    id: "XMLID_51_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_241_",
    transform: "translate(133.000000, 57.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8,9.2 C2.3,9.2 0.2,7.1 0.2,4.6 C0.2,2.1 2.3,-5.68434189e-14 4.8,-5.68434189e-14 C7.3,-5.68434189e-14 9.4,2.1 9.4,4.6 C9.4,7.1 7.3,9.2 4.8,9.2 Z",
    id: "XMLID_45_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_240_",
    transform: "translate(111.000000, 57.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,9.2 C2.7,9.2 0.6,7.1 0.6,4.6 C0.6,2.1 2.7,-5.68434189e-14 5.2,-5.68434189e-14 C7.7,-5.68434189e-14 9.8,2.1 9.8,4.6 C9.8,7.1 7.7,9.2 5.2,9.2 Z",
    id: "XMLID_39_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_238_",
    transform: "translate(90.000000, 57.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6,9.2 C2.1,9.2 0,7.1 0,4.6 C0,2.1 2.1,-5.68434189e-14 4.6,-5.68434189e-14 C7.1,-5.68434189e-14 9.2,2.1 9.2,4.6 C9.2,7.1 7.2,9.2 4.6,9.2 Z",
    id: "XMLID_62_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_177_",
    transform: "translate(143.000000, 10.000000)",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,135.5 L0,35.6 L0,35.6 C0,16 15.9,0 35.6,0 L36.4,0 C56,0 72,15.9 72,35.6 L72,122.2",
    id: "XMLID_204_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_153_",
    transform: "translate(70.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#D8D8D8",
    points: "36 28.8 4.8 23.4857143 28.6588235 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#5A5B5C",
    strokeWidth: 1.6,
    points: "56.8 100 36.3898041 29.1312643 28 0 0 22.4 36 29.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,0.2 L2.2,0.2 C1.6,0.2 1.2,0.6 1.2,1.2 L1.2,8.6 C1.2,9.2 1.6,9.6 2.2,9.6 L6.2,9.6 C6.8,9.6 7.2,9.2 7.2,8.6 L7.2,1.2 C7.2,0.7 6.8,0.2 6.2,0.2 Z",
    id: "XMLID_165_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 64,
    x2: 15,
    y2: 64,
    id: "XMLID_162_",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70,
    x2: 15,
    y2: 70,
    id: "XMLID_161_",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 76,
    x2: 15,
    y2: 76,
    id: "XMLID_160_",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 82,
    x2: 15,
    y2: 82,
    id: "XMLID_159_",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_",
    fill: "#F3F3F3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.157371,41.52 C155.995219,41.52 153.833068,41.68 151.750996,42 C150.309562,35.52 144.543825,30.72 137.737052,30.72 C135.65498,30.72 133.572908,31.2 131.811155,32 C128.688048,13.84 112.832271,0 93.7733068,0 C75.9155378,0 60.9406375,12.08 56.536255,28.56 C53.8135458,28.08 51.250996,27.84 48.4482072,27.84 C21.5414343,27.84 0,49.52 0,76.32 L0,94 L201,94 L201,76.96 C197.156175,56.8 179.458566,41.52 158.157371,41.52 Z",
    id: "XMLID_151_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,86.5434298 C373,51.2650334 353.981642,22 309.312473,22 C294.049841,22 278.7073,27.532294 267.759758,36.5122494 C260.807669,30.3385301 251.138672,26.3296214 241.150039,26.3296214 C220.213863,26.3296214 203.113322,41.5634744 198.878142,58.8017817 C197.679506,58.7216036 172.907695,59.5233853 166.035515,71.7906459 C165.955606,71.5501114 166.035515,94 166.035515,94 L373,94 L373,86.5434298 Z",
    id: "XMLID_150_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_141_",
    transform: "translate(20.000000, 0.000000)",
    stroke: "#DFDFDF",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,37 C7.83360522,31.364486 17.2659054,28 27.497553,28 C35.2512235,28 42.5252855,29.9345794 49,33.2990654",
    id: "XMLID_148_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,37.0602094 C240.544304,30.8324607 230.924051,27 220.341772,27 C200.219409,27 183.383966,40.7329843 178.654008,59.3363874 C167.350211,58.1387435 143.379747,62.8494764 134,88",
    id: "XMLID_147_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,44.7194581 C124.729172,43.6812606 127.618883,42.9625084 130.588865,42.4833404 C145.109996,40.2425427 159.32478,45.969804 169,56",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,42 C130.042017,37.4486692 126.928571,33.4562738 122.298319,31.6197719 C118.546218,30.1026616 114.47479,30.2623574 110.962185,31.8593156 C107.848739,13.7338403 92.0420168,0 73.0420168,0 C55.3991597,0 40.5504202,11.6577947 36,27.9467681",
    id: "XMLID_144_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,46 C253.227628,30.7046629 273.849696,21.768966 296.230235,23.1374962 C309.099044,23.9425139 320.928758,28.1286062 331,34.7297516",
    id: "XMLID_142_"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#474646",
    x: 139,
    y: 39,
    width: 80,
    height: 11,
    rx: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1145_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 57,
    cy: 61.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1053_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 292,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1058_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 233,
    cy: 51.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1144_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 1.5,
    cy: 143.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_973_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 55.5,
    cy: 113.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_938_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 248.5,
    cy: 26.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1059_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 262.5,
    cy: 36.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1060_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 307.5,
    cy: 62.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_966_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 33.5,
    cy: 68.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1140_",
    transform: "translate(21.300000, 102.000000)",
    stroke: "#DEDEDF",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.9,
    y1: 0,
    x2: 5.9,
    y2: 10,
    id: "XMLID_1142_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.9,
    y1: 5,
    x2: 0.9,
    y2: 5,
    id: "XMLID_1141_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_970_",
    transform: "translate(324.300000, 41.000000)",
    stroke: "#DEDEDF",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.9,
    y1: 0,
    x2: 5.9,
    y2: 10,
    id: "XMLID_972_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.9,
    y1: 5,
    x2: 0.9,
    y2: 5,
    id: "XMLID_971_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_",
    transform: "translate(340.300000, 113.000000)",
    stroke: "#DEDEDF",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.9,
    y1: 0,
    x2: 5.9,
    y2: 10,
    id: "XMLID_1057_"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.9,
    y1: 5,
    x2: 0.9,
    y2: 5,
    id: "XMLID_1056_"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1020_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 406,
    cy: 65.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_974_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 402.5,
    cy: 105.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1021_",
    fill: "#DEDEDF",
    fillRule: "nonzero",
    cx: 426.5,
    cy: 119.1,
    r: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEmptyState);
export default __webpack_public_path__ + "static/media/hidden_empty_state.1ed39fd22331d44a4873c64dbdb9b751.svg";
export { ForwardRef as ReactComponent };